import { action } from '@ember/object';
import Component from '@glimmer/component';

import FormCheckboxSwitchComponent from 'webapp/components/form/checkbox-switch';
import FormRadiobuttonGroupComponent from 'webapp/components/form/radiobutton-group';

import type Block from 'webapp/models-custom/block';

interface Args {
	blockM: Block;
}

export default class BlockSettingsConversionComponent extends Component<Args> {
	conversionOptions = [
		{
			value: false,
			label: 'Step by step',
		},
		{
			value: true,
			label: 'From first value',
		},
	];

	get block(): Block {
		return this.args.blockM;
	}

	get isConversionFromFirstValue(): boolean {
		return !!this.block.firstSliceConversion;
	}

	get showPercent(): boolean {
		return !this.block.hideStepConversion;
	}

	get showOverallConversionRate(): boolean {
		return !this.block.hideOverallConversionRate;
	}

	@action
	changeSelectedConversion(selected: AnySimpleValue): void {
		const block = this.block;
		block.firstSliceConversion = selected as boolean;
		block.blockSetup.saveBlock();
	}

	@action
	changeShowPercent(showPercent: boolean): void {
		const block = this.block;
		block.hideStepConversion = !showPercent;
		block.blockSetup.saveBlock();
	}

	@action
	changeShowOverallConversionRate(showOverallConversionRate: boolean): void {
		const block = this.block;
		block.hideOverallConversionRate = !showOverallConversionRate;
		block.blockSetup.saveBlock();
	}
	<template>
		<div class="row">
			<label>Step conversion</label>
			<FormRadiobuttonGroupComponent
				class="radiobutton-switcher"
				@name="stepConversion"
				@selected={{this.isConversionFromFirstValue}}
				@options={{this.conversionOptions}}
				@onChange={{this.changeSelectedConversion}}
				@theme="dark-blue"
			/>
		</div>

		<div class="row row--toggle">
			<FormCheckboxSwitchComponent
				@name="showPercent"
				@selected={{this.showPercent}}
				@onChange={{this.changeShowPercent}}
			/>
			<label>Show percent</label>
		</div>

		<div class="row row--toggle">
			<FormCheckboxSwitchComponent
				@name="showOverallConversionRate"
				@selected={{this.showOverallConversionRate}}
				@onChange={{this.changeShowOverallConversionRate}}
			/>
			<label>Show overall conversion rate</label>
		</div>
	</template>
}
